import { useState } from 'react';
import { Modal } from 'antd';

import PrecoPaymentPlanSetupStep from './PrecoPaymentPlanSetupStep';
import PrecoReviewScheduleStep from './PrecoReviewScheduleStep';
import PrecoEFTAStep from './PrecoEFTAStep';
import { PRECO_STEPS, resetPrecoState } from './precoState';

const PrecoSetupPaymentPlanModal = ({ hide, ...modalProps }) => {
  const [modalStep, setModalStep] = useState(PRECO_STEPS.FUNDING_ACCOUNT.key);

  const handleCancel = () => {
    resetPrecoState();
    setModalStep(PRECO_STEPS.FUNDING_ACCOUNT.key);
    hide();
  };

  const renderStep = () => {
    switch (modalStep) {
      case PRECO_STEPS.FUNDING_ACCOUNT.key:
        return (
          <PrecoPaymentPlanSetupStep
            onContinue={() => setModalStep(PRECO_STEPS.REVIEW_SCHEDULE.key)}
          />
        );
      case PRECO_STEPS.REVIEW_SCHEDULE.key:
        return (
          <PrecoReviewScheduleStep
            onContinue={() => setModalStep(PRECO_STEPS.EFTA.key)}
          />
        );
      case PRECO_STEPS.EFTA.key:
        return <PrecoEFTAStep onContinue={handleCancel} />;
      default:
        return null;
    }
  };

  return (
    <Modal
      {...modalProps}
      title="Set Up Payment Plan"
      width={800}
      footer={null}
      onCancel={handleCancel}
      destroyOnHidden={true}
    >
      <div style={{ marginTop: 'var(--spacing)' }}>{renderStep()}</div>
    </Modal>
  );
};

export default PrecoSetupPaymentPlanModal;
